import React from "react";
import { Link } from "react-router-dom";
import icon from "../assets/icons/onegat.webp";

const Contacto = () => {
  // Ofuscación sencilla del correo
  const emailUser = "onegat";
  const emailDomain = "onegat.es";
  const email = `${emailUser}@${emailDomain}`;

  // Mailto pre-relleno para la solicitud de demo
  const mailtoDemo = `mailto:${email}?subject=${
    encodeURIComponent("Solicitud demo ONEGAT - [Nombre Ayuntamiento]")
  }&body=${
    encodeURIComponent(
      "Hola,\n\n" +
        "Me gustaría solicitar acceso a la demo de ONEGAT.\n\n" +
        "Nombre:\n" +
        "Ayuntamiento o entidad:\n" +
        "Correo de contacto:\n" +
        "Teléfono (opcional):\n" +
        "Breve descripción del interés:\n\n" +
        "Gracias.\n"
    )
  }`;

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center py-5 min-vh-100">
      {/* Título */}
      <div className="w-75 bg-dark text-white py-4 text-center shadow-lg rounded">
        <h1 className="display-5 fw-bold">Contacto y solicitud de demo</h1>
      </div>

      {/* Descripción */}
      <p
        className="text-muted mt-4 text-center w-75"
        style={{ lineHeight: 1.8, fontSize: "1.05rem" }}
      >
        Si deseas evaluar <strong>ONEGAT</strong> en un entorno de pruebas supervisado,
        puedes solicitar acceso indicando tus datos de contacto y la entidad interesada.
      </p>

      <p
        className="text-muted mt-2 text-center w-75"
        style={{ lineHeight: 1.8, fontSize: "1.05rem" }}
      >
        Por favor, incluye en tu mensaje:
      </p>

      <ul className="text-muted w-75" style={{ fontSize: "1.0rem" }}>
        <li>Nombre y apellidos</li>
        <li>Ayuntamiento o entidad</li>
        <li>Correo electrónico de contacto</li>
        <li>Teléfono (opcional)</li>
        <li>Breve descripción del interés en la herramienta</li>
      </ul>

      {/* Botón principal: abre el correo ya pre-relleno */}
      <div className="mt-3">
        <a href={mailtoDemo} className="btn btn-primary btn-lg px-4">
          Enviar solicitud de demo
        </a>
      </div>

      {/* Correo visible como referencia (ofuscado) */}
      <div className="w-75 mt-3 text-center">
        <p className="text-muted" style={{ fontSize: "1.05rem" }}>
          📧 <strong>Correo de solicitud:</strong>{" "}
          <a href={`mailto:${email}`}>
            {emailUser}
            {"@"}
            {emailDomain}
          </a>
        </p>
      </div>

      {/* Aviso sobre la demo */}
      <div
        className="alert alert-warning mt-3 w-75 text-center"
        role="alert"
        style={{ lineHeight: 1.6, fontSize: "0.95rem" }}
      >
        <strong>Demo pública:</strong> versión gratuita y limitada para evaluación.
        No incluye compromiso de servicio continuado ni sustitución de herramientas
        oficiales de gestión. Evita introducir datos personales o información sensible.
        Cada entidad es responsable del uso que haga de los datos que introduzca en la plataforma.
      </div>

      {/* Imagen */}
      <img
        src={icon}
        alt="Onegat"
        className="mt-4 shadow-lg"
        style={{ width: "220px", height: "auto", borderRadius: "15px" }}
      />

      {/* Botón de regreso */}
      <Link to="/preview" className="mt-4 mb-5">
        <button className="btn btn-outline-primary btn-lg shadow-lg px-5 py-3 rounded-pill">
          Volver a Inicio
        </button>
      </Link>
    </div>
  );
};

export default Contacto;
